'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.unscopables.js
// module id = 278
// module chunks = 0